export default __webpack_public_path__ + "static/media/World_of_Sleepers_LE.195b76a5.jpg";